module.exports = __webpack_public_path__ + "img/logo_cdea.37c2c276.png";